import _ from 'lodash/fp'
import { assignLeft, createReducer, createTypes, createActions } from '@fe/redux/reducers/util'

const namespace = 'organisations'

const typeKeys = [
  'LOAD_REQUEST',
  'LOAD_REQUEST_DONE',
  'LOAD_SUCCESS',
  'LOAD_ERROR',

  'SUBMIT_REVIEW',
  'SUBMIT_REVIEW_ERROR',
  'SUBMIT_REVIEW_SUCCESS'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

function createSelectors () {
  const organisations = _.flow(
    _.get(`${namespace}.items`),
    _.orderBy(['name'], ['asc'])
  )

  const submitError = _.get(`${namespace}.submitError`)
  const submitSuccess = _.get(`${namespace}.submitSuccess`)
  const submitRequestWaiting = _.get(`${namespace}.submitRequestWaiting`)

  return {
    organisations,
    submitError,
    submitSuccess,
    submitRequestWaiting
  }
}

export const selectors = createSelectors()

export const initialState = {
  items: {},
  loadRequestWaiting: false,
  loadError: null,
  loadedAt: null,
  submitRequestWaiting: false,
  submitError: false,
  submitSuccess: false
}

const reducer = {
  [types.LOAD_REQUEST]: p => assignLeft({ loadRequestWaiting: true, loadError: null }),
  [types.LOAD_REQUEST_DONE]: p => assignLeft({ loadRequestWaiting: false }),
  [types.LOAD_SUCCESS]: p => _.set('items', p),
  [types.LOAD_ERROR]: p => assignLeft({ loadError: p }),
  [types.SUBMIT_REVIEW]: p => assignLeft({ submitRequestWaiting: true, submitError: false, submitSuccess: false }),
  [types.SUBMIT_REVIEW_ERROR]: p => assignLeft({ submitRequestWaiting: false, submitError: p }),
  [types.SUBMIT_REVIEW_SUCCESS]: p => assignLeft({ submitRequestWaiting: false, submitSuccess: true })
}

export default createReducer(initialState, reducer)
